var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group-b",
    preserveAspectRatio: "xMidYMin meet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1366 607.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 303.8,
    x2: 1366,
    y2: 303.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#190740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#166f45"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Background",
    d: "M0,0H1366V538l-11.54,3.35a1667.44,1667.44,0,0,1-856.18,19.8L0,441Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBackground);
export default __webpack_public_path__ + "static/media/servicesBackground.fc35c9bb1b814040536b91db0076af89.svg";
export { ForwardRef as ReactComponent };